<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="height"
         viewBox="0 0 1024 1024">
        <metadata><?xpacket begin="﻿" id="W5M0MpCehiHzreSzNTczkc9d"?>
            <x:xmpmeta xmlns:x="adobe:ns:meta/"
                       x:xmptk="Adobe XMP Core 5.6-c138 79.159824, 2016/09/14-01:09:01">
                <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
                    <rdf:Description rdf:about=""/>
                </rdf:RDF>
            </x:xmpmeta>
            <?xpacket end="w"?></metadata>
        <image x="85" y="128" width="854" height="768"
               xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAMAAABsDg4iAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAclBMVEV5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPt5nPsAAAA9EqtXAAAAJHRSTlMATd7y4FEF9/gP+w7z9vUBDQz+HhIJCxoEE07i41MCEQMf+k85wBAXAAAAAWJLR0QlwwHJDwAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+QJBw8ON/ykZkAAAACQSURBVBjTdY/bEoIgEEC3sDLSQFmzu5b7/98YtwWapvMCnJk9AEBktRaRasNuu6NEzXIvs5QsDw21R09LjRNKa+h6Mugx1Ds5CAGKiIfC7uSWP3LUntGebG8gOkNd3h56F7je2N0fEEafHJwQZ4jypTsocL38xTdGibCkno0HqYrepKI03z1Hfp/EJJfqV34AvUYWV4qS6JoAAAAASUVORK5CYII="/>
    </svg>

</template>

<script>
    export default {
        name: "ICascade",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
